import React from "react";
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import { fetchServer } from "../Base/modelManager";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { Button, Container } from "react-bootstrap";
import { serverError } from "../../redux/actions/serverManagerAction";
import { message } from "antd";
import { Navigate } from "react-router-dom";




class password extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            data: {
                current:'',
                password:'',
                confirm:''
            },
            loadding: false,
            passwordChange:false,
        }
    }

    componentDidMount() {
        
    }

 

    onPropertyChange = (event) => {
        const { data } = this.state
        data[event.target.name] = event.target.value
        this.setState({ data: { ...data } })
    }


    render() {
        const { data,passwordChange } = this.state

        if (passwordChange===true)
            return (
                <Navigate to='/' replace />
        )
else
        return (
            <section>
                <Container id="AdrCorrespondance" className="justify-content-md-center">
                    <Row className="header">
                        - MODIFICATION DU MOT DE PASSE -
                    </Row>
                    <Row>
                        <Col sm="5">
                            Mot de passe actuel
                        </Col>
                        <Col sm="7">
                            <Form.Control type="password" name='current' value={data.current} onChange={this.onPropertyChange} />
                        </Col>
                    </Row>
                    <Row>
                        <Col sm="5">
                            Nouveau Mot de passe
                        </Col>
                        <Col sm="7">
                            <Form.Control type="password" name='password' value={data.password} onChange={this.onPropertyChange} />
                        </Col>
                    </Row>
                    <Row>
                        <Col sm="5">

                        </Col>
                        <Col sm="7">
                            <Form.Control placeholder="confirmez le nouveau mot de passe" type="password" name='confirm' value={data.confirm} onChange={this.onPropertyChange} />
                        </Col>
                    </Row>
                    <Row className="justify-content-md-center">
                        <Button id='saveAdresse' onClick={() => {
                            const {data}=this.state

                            if (data.confirm!==data.password ) {
                                this.props.dispatch(serverError('la confirmation est diférente du nouveau mot de passe'))
                                return
                            }

                            const request = {
                                endPoint: this.props.authUrl + '/ResetPassword',
                                method: 'POST',
                                params : {
                                    code : data.current,
                                    password: data.password,
                                    passwordconfirmation: data.confirm
                                },
                                token: this.props.JWTToken
                            }
                            fetchServer(request,
                                (json) => {
                
                                    this.setState({  loading: false, passwordChange:true })
                                    message.info('Le mot de passe a été modifié',5)
                                },
                                (json) => {
                                    this.setState({ data: {}, loading: false })
                                    this.props.dispatch(serverError(json.error))
                                }
                
                
                            )
                        }}>Enregistrer</Button>
                    </Row>

                </Container>



            </section>
        )
    }
}


const mapStateToProps = (state) => {

    return ({
        currentClient: state.authentication.currentClient,
        JWTToken: state.authentication.JWTToken,
        authUrl: state.server.authUrl,
    })
}

password.propTypes = {
    dispatch: PropTypes.func,
    location: PropTypes.object,
    currentClient: PropTypes.object,
    JWTToken: PropTypes.string,
    authUrl: PropTypes.string
};

export default connect(mapStateToProps)(password);
